import { render, staticRenderFns } from "./ScopePreview.vue?vue&type=template&id=33c12534&"
import script from "./ScopePreview.vue?vue&type=script&lang=js&"
export * from "./ScopePreview.vue?vue&type=script&lang=js&"
import style0 from "./ScopePreview.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ScopePreview.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports